/* Auto-bold any line in a PDP accordion that ends with a colon.
   Lets content editors use plain rich-text metafields and still get bold
   "Composition:" / "Care Instructions:" style headings. */
(function () {
  // Wrap a text node's content in <strong> if the trimmed text ends with ":".
  function maybeBoldTextNode(node) {
    const text = node.nodeValue;
    if (!text) return;
    const trimmed = text.trim();
    if (trimmed.length === 0) return;
    if (!trimmed.endsWith(':')) return;
    if (trimmed.length > 80) return; // avoid bolding long sentences that happen to end in ":"

    const strong = document.createElement('strong');
    strong.textContent = trimmed;
    // Preserve surrounding whitespace
    const leading = text.match(/^\s*/)[0];
    const trailing = text.match(/\s*$/)[0];
    const frag = document.createDocumentFragment();
    if (leading) frag.appendChild(document.createTextNode(leading));
    frag.appendChild(strong);
    if (trailing) frag.appendChild(document.createTextNode(trailing));
    node.parentNode.replaceChild(frag, node);
  }

  // For an element, look at children separated logically by <br> or block boundaries.
  // Simplest approach: if the element contains only a single text node (or text + <br>s),
  // split by <br> and bold any segment ending in ":".
  function processBlock(el) {
    const children = Array.from(el.childNodes);
    // If already contains a <strong> that wraps the whole thing, skip.
    if (
      children.length === 1 &&
      children[0].nodeType === 1 &&
      children[0].tagName === 'STRONG'
    ) {
      return;
    }

    // Rebuild: walk children, splitting text nodes by their content, treating <br> as line break.
    // For each "line" (sequence between <br> or start/end), if the concatenated trimmed text ends in ":",
    // wrap that line's content in <strong>.
    const lines = [[]]; // array of arrays of nodes
    children.forEach((child) => {
      if (child.nodeType === 1 && child.tagName === 'BR') {
        lines.push([]);
      } else {
        lines[lines.length - 1].push(child);
      }
    });

    let changed = false;
    const newChildren = [];
    lines.forEach((lineNodes, i) => {
      if (i > 0) newChildren.push(document.createElement('br'));
      const textContent = lineNodes.map((n) => n.textContent).join('').trim();
      const endsWithColon = textContent.endsWith(':') && textContent.length > 0 && textContent.length <= 80;
      const alreadyBold =
        lineNodes.length === 1 &&
        lineNodes[0].nodeType === 1 &&
        lineNodes[0].tagName === 'STRONG';

      if (endsWithColon && !alreadyBold) {
        const strong = document.createElement('strong');
        lineNodes.forEach((n) => strong.appendChild(n.cloneNode(true)));
        newChildren.push(strong);
        changed = true;
      } else {
        lineNodes.forEach((n) => newChildren.push(n.cloneNode(true)));
      }
    });

    if (changed) {
      el.innerHTML = '';
      newChildren.forEach((n) => el.appendChild(n));
    }
  }

  function transform(root) {
    if (!root || root.dataset.autoBolded === '1') return;
    // Process each block-level child (p, div, li) and the root itself if it has only inline content.
    // Find every element that directly contains a <br> — that's the "line container".
    const brs = root.querySelectorAll('br');
    const blockSet = new Set();
    brs.forEach((br) => blockSet.add(br.parentNode));
    // Also include p/div/li so single-line paragraphs (no <br>) still get processed.
    root.querySelectorAll('p, div, li').forEach((el) => blockSet.add(el));
    const blocks = Array.from(blockSet);
    if (blocks.length > 0) {
      blocks.forEach(processBlock);
    } else {
      processBlock(root);
    }
    root.dataset.autoBolded = '1';
  }

  function run() {
    document.querySelectorAll('.accordion__content').forEach(transform);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
